import { allProducts } from '../mocks/products';

const STOCK_KEY = 'productStock';

export interface StockMap {
  [productId: number]: number;
}

/** 현재 재고 맵 반환 (없으면 mock 기본값으로 초기화) */
export function getStockMap(): StockMap {
  const saved = localStorage.getItem(STOCK_KEY);
  if (saved) {
    try {
      return JSON.parse(saved) as StockMap;
    } catch {
      // 파싱 실패 시 기본값 사용
    }
  }
  const initial: StockMap = {};
  allProducts.forEach((p) => {
    initial[p.id] = p.stock;
  });
  localStorage.setItem(STOCK_KEY, JSON.stringify(initial));
  return initial;
}

/** 재고 맵 저장 */
export function saveStockMap(map: StockMap): void {
  localStorage.setItem(STOCK_KEY, JSON.stringify(map));
}

/** 특정 상품 재고 조회 */
export function getStock(productId: number): number {
  const map = getStockMap();
  return map[productId] ?? 0;
}

/** 주문 시 재고 차감 (items: [{id, quantity}]) */
export function deductStock(items: { id: string | number; quantity: number }[]): void {
  const map = getStockMap();
  items.forEach(({ id, quantity }) => {
    const numId = typeof id === 'string' ? parseInt(id, 10) : id;
    if (!isNaN(numId) && map[numId] !== undefined) {
      map[numId] = Math.max(0, map[numId] - quantity);
    }
  });
  saveStockMap(map);
}

/** 주문 취소 시 재고 복구 (items: [{id, quantity}]) */
export function restoreStock(items: { id: string | number; quantity: number }[]): void {
  const map = getStockMap();
  items.forEach(({ id, quantity }) => {
    const numId = typeof id === 'string' ? parseInt(id, 10) : id;
    if (!isNaN(numId)) {
      const original = allProducts.find((p) => p.id === numId)?.stock ?? 9999;
      map[numId] = Math.min(original, (map[numId] ?? 0) + quantity);
    }
  });
  saveStockMap(map);
}
